import { createAction, props } from '@ngrx/store'
import { EntityTagsResponse } from './model'

export const LoadEntityTags = createAction('[EntityTag] Load EntityTags')
export const LoadEntityTagsComplete = createAction(
  '[EntityTag] Load EntityTags Complete',
  props<{ items: EntityTagsResponse[] }>()
)

export const SetEntityTags = createAction(
  '[EntityTag] Set Tags',
  props<{ tags: string[]; entityType: string; entityId: string; silent?: boolean }>()
)
export const SetEntityTagsComplete = createAction(
  '[EntityTag] Set Tags Complete',
  props<{ item: EntityTagsResponse }>()
)
